const CARD_SLOT_SELECTORS = [
  ".product__text",
  ".product__articule",
  ".product__brand",
  ".product__availability",
  ".product__price",
];

const getCardRows = (cards) => {
  return cards.reduce((rows, card) => {
    const top = Math.round(card.getBoundingClientRect().top);
    const row = rows.find((item) => Math.abs(item.top - top) <= 2);

    if (row) {
      row.cards.push(card);
    } else {
      rows.push({ top, cards: [card] });
    }

    return rows;
  }, []);
};

const getAlignmentGroups = () => {
  const groups = [];

  document.querySelectorAll(".products__container").forEach((container) => {
    const cards = Array.from(container.children).filter((item) =>
      item.classList.contains("product")
    );
    groups.push(...getCardRows(cards).map((row) => row.cards));
  });

  document.querySelectorAll(".viewed--cards").forEach((slider) => {
    const cards = Array.from(slider.querySelectorAll(".swiper-slide > .product"));
    if (cards.length) groups.push(cards);
  });

  return groups;
};

const alignProductCards = () => {
  const cards = Array.from(document.querySelectorAll(
    ".products__container > .product, .viewed--cards .swiper-slide > .product"
  ));

  cards.forEach((card) => {
    CARD_SLOT_SELECTORS.forEach((selector) => {
      const slot = card.querySelector(selector);
      if (slot) slot.style.minHeight = "";
    });
  });

  const groups = getAlignmentGroups();
  if (!groups.length) return;

  groups.forEach((cardsInGroup) => {
    CARD_SLOT_SELECTORS.forEach((selector) => {
      const slots = cardsInGroup
        .map((card) => card.querySelector(selector))
        .filter(Boolean);
      const maxHeight = Math.max(0, ...slots.map((slot) => slot.getBoundingClientRect().height));

      slots.forEach((slot) => {
        slot.style.minHeight = `${Math.ceil(maxHeight)}px`;
      });
    });
  });
};

let alignmentFrame = 0;
const scheduleProductCardAlignment = () => {
  cancelAnimationFrame(alignmentFrame);
  alignmentFrame = requestAnimationFrame(alignProductCards);
};

const alignmentRoots = document.querySelectorAll("#categoryPage, .viewed--cards");
if (alignmentRoots.length) {
  const observer = new MutationObserver(scheduleProductCardAlignment);
  alignmentRoots.forEach((root) => observer.observe(root, {
    childList: true,
    subtree: true,
  }));

  window.addEventListener("load", scheduleProductCardAlignment);
  window.addEventListener("resize", scheduleProductCardAlignment);
  document.fonts?.ready.then(scheduleProductCardAlignment);
  scheduleProductCardAlignment();
}
